import { observable, makeAutoObservable } from 'mobx';
import { HeadlineCarouselDataState } from 'src/AppState/CmsState/HeadlineCarouselDataState/HeadlineCarouselData.state';

export class DateState {
    constructor(private readonly headlineCarouselState: HeadlineCarouselDataState) {
        makeAutoObservable(this);
    }
    @observable public startDateError = false;
    @observable public endDateError = false;

    public onChangeStartDate = (date: Date | null): void => {
        if (date !== null) {
            this.headlineCarouselState.dateStart.setValue(date.toISOString());
        }
    };

    public onBlurStartDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.startDateError = true;
        } else if (this.startDateError) {
            this.startDateError = false;
        }
    };

    public onChangeEndDate = (date: Date | null): void => {
        if (date !== null) {
            this.headlineCarouselState.dateEnd.setValue(date.toISOString());
        }
    };

    public onBlurEndDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.endDateError = true;
        } else if (this.endDateError) {
            this.endDateError = false;
        }
    };

    public preventDefault = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
    };
}
